import { render, staticRenderFns } from "./SanatoriumIndex.vue?vue&type=template&id=a1d29bf8&scoped=true&"
import script from "./SanatoriumIndex.vue?vue&type=script&lang=js&"
export * from "./SanatoriumIndex.vue?vue&type=script&lang=js&"
import style0 from "./SanatoriumIndex.vue?vue&type=style&index=0&id=a1d29bf8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1d29bf8",
  null
  
)

export default component.exports